module.exports = __webpack_public_path__ + "img/8-1.c059e1b0.jpg";